import React, { useState } from 'react';
import PropTypes from 'prop-types';

import TreatmentPageTabs from '../TreatmentPageTabs';
import TreatmentPlanTab from '../TreatmentPlanTab';
import HelpAndFaqTab from '../HelpAndFaqTab';
import FoodJournalTab from '../FoodJournalTab';

import { TREATMENT_TYPES } from '../../constants/treatment';

import './index.scss';

const TABS = {
  TREATMENT_PLAN: 'treatmentPlan',
  HELP_AND_FAQ: 'helpAndFaq',
  FOOD_JOURNAL: 'foodJournal',
};

const TabComponents = {
  [TABS.TREATMENT_PLAN]: TreatmentPlanTab,
  [TABS.HELP_AND_FAQ]: HelpAndFaqTab,
  [TABS.FOOD_JOURNAL]: FoodJournalTab,
};

const getTabsData = (treatmentType) => {
  if (treatmentType === TREATMENT_TYPES.IMMUNOTHERAPY_TREATMENT) {
    return [
      { id: TABS.TREATMENT_PLAN, label: 'treatment-plan' },
      { id: TABS.HELP_AND_FAQ, label: 'help-and-faq' },
    ];
  }

  if (treatmentType === TREATMENT_TYPES.NUTRITION_ADVICE) {
    return [
      { id: TABS.TREATMENT_PLAN, label: 'treatment-plan' },
      { id: TABS.FOOD_JOURNAL, label: 'food-journal' },
    ];
  }

  return null;
};

const TreatmentPageTabsSection = ({ data, dispatch }) => {
  const { treatment } = data;
  const [activeTab, setActiveTab] = useState(TABS.TREATMENT_PLAN);

  const tabsData = getTabsData(treatment.type);

  const TabContent = TabComponents[activeTab];

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const bannerStyleButtonOnClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className='treatment-page-tabs-section'>
      <TreatmentPageTabs
        tabs={tabsData}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      <div className='treatment-page-tabs-section__content'>
        {TabContent && (
          <TabContent
            data={data}
            bannerStyleButtonOnClick={bannerStyleButtonOnClick}
            dispatch={dispatch}
          />
        )}
      </div>
    </div>
  );
};

TreatmentPageTabsSection.propTypes = {
  data: PropTypes.object,
  dispatch: PropTypes.func,
};

export default TreatmentPageTabsSection;
